import $ from "jquery"
import { trace } from "./../shared/helpers.js"

const Print = {
  
  init() {
    $('body').on('click', 'a.print-me', (e)=> {
      e.preventDefault();
      window.print();
    });
  }

}

export default Print;